import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const firstaid = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
